import camel_case from "@/helpers/filters/camel_case";

/**
 * Generates a mixin for two-way binding with a prop and event.
 *
 * @param {string} key - The name of the prop to bind.
 * @param {string} eventName - The name of the event to emit for updates.
 * @example
 * export default {
 *   mixins: [modelValue("value", "change")],
 *   props: {
 *     value: {
 *       type: Number,
 *       default: 0,
 *     },
 *   },
 *   mounted() {
 *     this.modelValue++;
 *     console.log(this.modelValue); // 1
 *   },
 * };
 *
 * @returns {import('vue').ComponentOptions<Vue>} A Vue mixin object.
 */
export function modelValue(key, eventName) {
  const modelName = camel_case(`model ${key}`);
  return {
    model: {
      prop: key,
      event: eventName,
    },
    computed: {
      [modelName]: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit(eventName, value);
        },
      },
    },
  };
}
